export const addCommasToNumber = num => {
  if (num) {
    return num?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  } else {
    return '0';
  }
};


export const numberToWordsIndian = (num) => {
  // Input validation
  if (isNaN(num) || num < 0 || !Number.isInteger(num)) {
    return null;
  }
  // Handle zero case
  if (num === 0) {
    return "Zero";
  }
  // Arrays for words
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 
                'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  // Handle two digits numbers (1-99)
  function convertTwoDigits(n) {
    if (n < 20) {
      return ones[n];
    }
    return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? '-' + ones[n % 10].toLowerCase() : '');
  }
  // Handle three digits (100-999)
  function convertThreeDigits(n) {
    if (n < 100) {
      return convertTwoDigits(n);
    }
    return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + convertTwoDigits(n % 100) : '');
  }
  // Convert to words
  let result = '';
  // Extract parts according to Indian number system
  const crore = Math.floor(num / 10000000);
  const lakh = Math.floor((num % 10000000) / 100000);
  const thousand = Math.floor((num % 100000) / 1000);
  const hundreds = num % 1000;
  // Add crores
  if (crore > 0) {
    if (crore === 100) {
      result += 'Hundred Crore ';
    } else {
      result += convertTwoDigits(crore) + ' Crore ';
    }
  }
  // Add lakhs
  if (lakh > 0) {
    result += convertTwoDigits(lakh) + ' Lakh ';
  }
  // Add thousands
  if (thousand > 0) {
    result += convertThreeDigits(thousand) + ' Thousand ';
  }
  // Add hundreds, tens and ones
  if (hundreds > 0) {
    result += convertThreeDigits(hundreds);
  }
  return result.trim();
}


export const formatIndianCurrency = (number) => {
  if (isNaN(number) || number === null) {
    return number;
  }
  
  // Convert number to a fixed two decimal place string
  let numStr = Number(number).toFixed(2);
  let parts = numStr.split('.');
  let integerPart = parts[0];
  let decimalPart = parseFloat(parts[1]) > 0 ? '.' + parts[1] : '';
  
  // Handle negative numbers
  let isNegative = false;
  if (integerPart.startsWith('-')) {
    isNegative = true;
    integerPart = integerPart.substring(1);
  }
  
  // Format with Indian numbering system (lakhs and crores)
  let formattedNumber = '';
  let length = integerPart.length;
  
  if (length <= 3) {
    formattedNumber = integerPart;
  } else {
    formattedNumber = integerPart.substring(length - 3);
    integerPart = integerPart.substring(0, length - 3);
    
    while (integerPart.length > 0) {
      let chunk = integerPart.substring(Math.max(0, integerPart.length - 2));
      formattedNumber = chunk + "," + formattedNumber;
      integerPart = integerPart.substring(0, integerPart.length - 2);
    }
  }
  
  if (isNegative) {
    formattedNumber = '-' + formattedNumber;
  }
  
  return formattedNumber + decimalPart;
};

export const  isEmptyObject =(obj)=> {
  // Check if input is actually an object
  if (obj === null ||obj === undefined || typeof obj !== 'object' || Array.isArray(obj)) {
    return false;
  }
  
  // Check if the object has any own enumerable properties
  return Object.keys(obj).length === 0;
}